export const MAX_THICKNESS_MULTIPLIER = 8;

const THRESHOLDS_NM: Record<string, number> = {
  H: 0,
  He: 0,
  O: 0,
  C: 0.5,
  Si: 1,
  Fe: 1.5,
  P: 2,
  K: 2,
};

export function proximityThresholdNm(elementSymbol: string): number {
  return THRESHOLDS_NM[elementSymbol] ?? 0;
}
